export const muiThemeVariables = {
  textInputPaddingY: "8px",
  textInputPaddingX: "10px",
};
